/* eslint-disable no-restricted-syntax */
import React, { useContext, useEffect, useState } from 'react'
import { Animate } from 'react-move'
import StepsContext from '../../contexts/StepsContext'
// eslint-disable-next-line import/extensions, import/no-absolute-path

export default function SidebarQuestions(): React.ReactElement {
	const { steps, currentStep } = useContext(StepsContext)
	const [animation, setAnimation] = useState<{ width: number }>({
		width: 0,
	})
	useEffect(() => {
		const header = document.querySelector('.menu')
		if (header) {
			header.classList.add('header--margin-left', 'header--centralize')
		}
	})

	useEffect(() => {
		const { innerWidth: width } = window
		const paddingContainerQuestions = 48
		if (steps.length && width <= 800) {
			const containerQuestions =
				document.querySelector('.sidebar-questions')

			const nextStep = document.querySelector(`#container-${currentStep}`)
			if (nextStep && containerQuestions) {
				const widthContainerQuestions =
					containerQuestions.clientWidth -
					paddingContainerQuestions * 2
				// espaço que sobraria no container para centralizar a proxima div
				const spaceLeftOver =
					widthContainerQuestions - nextStep.clientWidth

				const dashedBarHorizontal =
					currentStep === steps.length - 1
						? 0
						: nextStep.getElementsByTagName('div')[3].clientWidth
				const dashedBarWidth = dashedBarHorizontal / 2
				const widthMoveToLeft =
					nextStep.getBoundingClientRect().left -
					paddingContainerQuestions -
					dashedBarWidth -
					spaceLeftOver / 2
				setAnimation({
					width: animation.width + widthMoveToLeft,
				})
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentStep])
	return (
		<div className="sidebar-questions">
			{steps.map((q, index) => (
				<Animate start={{ width: 0 }} key={q._id}>
					{() => (
						<div
							className="sidebar-questions__container"
							style={{
								opacity: currentStep === index ? 1 : 0.45,
								fontFamily:
									currentStep === index
										? 'mont-semi-bold'
										: 'mont-regular',
								transform: `translate(-${
									animation.width < 0
										? animation.width * -1
										: animation.width
								}px, 0)`,
								fontSize: '1.5rem',
								// left: getLeftPositionContainer(index),
							}}
							id={`container-${index}`}
							key={`${q._id}`}
						>
							<div
								style={{
									flexGrow: 1,
									display: 'flex',
									alignItems: 'center',
								}}
							>
								{index >= currentStep ? (
									<div className="sidebar-questions__container__steps">
										{index + 1}
									</div>
								) : (
									<img
										src="/assets/img/outhers/checked.svg"
										alt="Concluído"
										title="Concluído"
										style={{
											width: '1.7rem',
											height: '1.7rem',
										}}
									/>
								)}
							</div>
							<div
								style={{
									flexGrow: 2,
									width: '70% ',
									display: 'flex',
									whiteSpace: 'nowrap',
								}}
							>
								{q.name}{' '}
								{steps.length !== index + 1 && (
									<div className="sidebar-questions__container__border--dashed--horizontal" />
								)}
							</div>
							{steps.length !== index + 1 && (
								<div className="sidebar-questions__container__border--dashed--vertical" />
							)}
						</div>
					)}
				</Animate>
			))}
		</div>
	)
}
